import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import app_setting_gen_2 from '@devices/settings/device_settings/app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import settings_gen_2 from '@devices/settings/device_settings/settings_gen_2.js';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';

export default {
	name: 'Shelly2LG3',
	friendly_name: '2L Gen3',
	family: 'relay',
	reset_from_input: true,
	modes: {
		relay: {
			channels: 2,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_bt_home_control_gen_2,
				app_setting_gen_2,
				share,
				settings_gen_2,
			],
		},
	},
};
